import React, {Component} from 'react';
import {APIClient} from '../../../utils/APIClient';
import {API_URL} from '../../../settings/local_settings';
import {AccessService} from '../../../utils/AccessService';
import {LocalStorage} from '../../../utils/LocalStorage';
import {ClientHeader} from '../ClientHeader';
import {ClientTabs} from '../ClientTabs';
import {Spinner} from '../../Spinner';
import {BUSummaryBox} from './BUSummaryBox';
import {PlatformsBox} from './PlatformsBox';
import {QuickConnectAccountModal} from './QuickConnectAccountModal';
import {ReportsPreviewBox} from './ReportsPreviewBox';
import {ActivityLogPreviewBox} from './ActivityLogPreviewBox';
import {ClientUsersPreviewBox} from './ClientUsersPreviewBox';
import {ActivityLogCommentModal} from '../activity_log/ActivityLogCommentModal';
import {AddBusinessUnitModal} from '../AddBusinessUnitModal';
import {CHANNEL_INFO_BY_CHANNEL, CHANNEL_TYPE_ECOMMERCE} from '../../channels/channels';
import {TemplatePickerModal} from '../../reports/TemplatePickerModal';
import {withTranslation} from 'react-i18next';
import './ControlCentral.scss';

class ControlCentralContentClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            businessUnits: null,
            clientAdAccounts: null,
            clientStores: null,
            channels: null,
            reports: [],
            activityLogEntries: [],
            loadingClient: true,
            loadingReports: true,
            loadingActivityLog: true,
            modules: null,
            ignoredChannels: null,
            generating: false,
            showTemplateModal: false,
            showCommentModal: false,
            isSubmittingComment: false,
            showConnectModal: false,
            connectModalChannel: null,
        };

        this.handleGenerateReport = this.handleGenerateReport.bind(this);
        this.handleGenerateTemplate = this.handleGenerateTemplate.bind(this);
        this.toggleTemplateModal = this.toggleTemplateModal.bind(this);
        this.handleDeleteReport = this.handleDeleteReport.bind(this);
        this.handleCancelReport = this.handleCancelReport.bind(this);
        this.toggleCommentModal = this.toggleCommentModal.bind(this);
        this.handleCommentSubmit = this.handleCommentSubmit.bind(this);
        this.handleAfterSuccessfulBUSubmit = this.handleAfterSuccessfulBUSubmit.bind(this);
        this.handleOpenAddBUModal = this.handleOpenAddBUModal.bind(this);
        this.handleConnectChannel = this.handleConnectChannel.bind(this);
        this.toggleConnectModal = this.toggleConnectModal.bind(this);
        this.handleConnectSuccess = this.handleConnectSuccess.bind(this);
        this.handleIgnoreChannel = this.handleIgnoreChannel.bind(this);
        this.handleUnignoreChannel = this.handleUnignoreChannel.bind(this);
    }

    componentDidMount() {
        this.fetchClientData();
        this.fetchModules();
    }

    fetchModules() {
        const userId = LocalStorage.fetchUserId();
        if (!userId) {
            this.setState({modules: [], loadingReports: false, loadingActivityLog: false});
            return;
        }
        AccessService.GetUserModules(userId, (data) => {
            const modules = data.modules || [];
            this.setState({modules}, () => {
                if (this.hasReportsModule()) {
                    this.fetchReports();
                } else {
                    this.setState({loadingReports: false});
                }
                if (this.hasActivityLogModule()) {
                    this.fetchActivityLog();
                } else {
                    this.setState({loadingActivityLog: false});
                }
            });
        }, () => {
            // Error handler — unblock loading state
            this.setState({modules: [], loadingReports: false, loadingActivityLog: false});
        });
    }

    hasAgentModule() {
        return this.state.modules && this.state.modules.includes(AccessService.MODULE_AGENT);
    }

    hasReportsModule() {
        return this.state.modules && this.state.modules.includes(AccessService.MODULE_REPORTS);
    }

    hasActivityLogModule() {
        return this.state.modules && this.state.modules.includes(AccessService.MODULE_ACTIVITY_LOG);
    }

    fetchClientData() {
        new APIClient(API_URL + 'client/' + this.props.clientId).call('GET').then((data) => {
            if (data && data.status === 'OK') {
                this.setState({
                    name: data.data.name,
                    businessUnits: data.data.business_units,
                    clientAdAccounts: data.data.client_ad_accounts,
                    clientStores: data.data.client_stores,
                    channels: data.data.channels,
                    ignoredChannels: data.data.ignored_channels || [],
                    loadingClient: false,
                });
            } else {
                this.setState({loadingClient: false});
            }
        });
    }

    fetchReports() {
        new APIClient(API_URL + 'reports/?client_id=' + this.props.clientId).call('GET').then((data) => {
            if (data && data.status === 'OK') {
                this.setState({
                    reports: data.data.reports || [],
                    loadingReports: false,
                });
            } else {
                this.setState({loadingReports: false});
            }
        });
    }

    fetchActivityLog() {
        const url = API_URL + 'client/' + this.props.clientId + '/activity-log/?page_size=10';
        new APIClient(url).call('GET').then((data) => {
            if (data && data.status === 'OK') {
                this.setState({
                    activityLogEntries: data.data.entries || [],
                    loadingActivityLog: false,
                });
            } else {
                this.setState({loadingActivityLog: false});
            }
        });
    }

    handleGenerateReport() {
        this.setState({showTemplateModal: true});
    }

    toggleTemplateModal() {
        this.setState({showTemplateModal: !this.state.showTemplateModal});
    }

    handleGenerateTemplate(templateSlug, visibleToClients = true, isPublic = true) {
        this.setState({generating: true, showTemplateModal: false});
        const body = {
            action_type: 'template_report',
            template_slug: templateSlug,
            client_id: this.props.clientId,
            is_visible_to_clients: visibleToClients,
            is_public: isPublic,
        };
        new APIClient(API_URL + 'agent/trigger-action/').call('POST', body).then((data) => {
            this.setState({generating: false});
            if (data && data.status === 'OK') {
                const newReport = {
                    report_id: data.data.report_id,
                    title: this.props.t('client_reports.generating'),
                    generated_at: new Date().toISOString(),
                    status: 'PROCESSING',
                    url: null,
                    block_count: 0,
                    can_delete: true,
                };
                this.setState(prevState => ({
                    reports: [newReport, ...prevState.reports],
                }));
            } else if (data) {
                const {t} = this.props;
                if (data.status === 'ALREADY_PROCESSING') {
                    alert(t('client_reports.error_already_processing'));
                } else {
                    alert(data.error_message || 'Error');
                }
            }
        });
    }

    handleDeleteReport(reportId) {
        const {t} = this.props;
        if (!window.confirm(t('client_reports.delete_confirm'))) return;

        new APIClient(API_URL + 'reports/' + reportId + '/').call('DELETE').then((data) => {
            if (data && data.status === 'OK') {
                this.setState(prevState => ({
                    reports: prevState.reports.filter(r => r.report_id !== reportId),
                }));
            }
        });
    }

    handleCancelReport(reportId) {
        const {t} = this.props;
        if (!window.confirm(t('client_reports.cancel_confirm'))) return;

        new APIClient(API_URL + 'reports/' + reportId + '/').call('DELETE').then((data) => {
            if (data && (data.status === 'OK' || data.status === 'FORBIDDEN')) {
                this.fetchReports();
            }
        });
    }

    toggleCommentModal() {
        this.setState({showCommentModal: !this.state.showCommentModal});
    }

    handleCommentSubmit(commentText, buId) {
        this.setState({isSubmittingComment: true});
        const body = {comment_text: commentText};
        if (buId) body.business_unit_id = buId;

        new APIClient(API_URL + 'client/' + this.props.clientId + '/activity-log/').call('POST', body).then((data) => {
            this.setState({isSubmittingComment: false});
            if (data && data.status === 'OK') {
                this.setState({showCommentModal: false});
                this.fetchActivityLog();
            } else if (data) {
                alert(data.error_message || 'Error');
            }
        });
    }

    handleConnectChannel(channel) {
        const info = CHANNEL_INFO_BY_CHANNEL[channel];
        if (info && info.channelType === CHANNEL_TYPE_ECOMMERCE) {
            this.props.history.push(`/client/${this.props.clientId}/conections`);
            return;
        }
        this.setState({showConnectModal: true, connectModalChannel: channel});
    }

    toggleConnectModal() {
        this.setState({showConnectModal: !this.state.showConnectModal, connectModalChannel: null});
    }

    handleConnectSuccess() {
        this.fetchClientData();
    }

    handleIgnoreChannel(channel) {
        const body = {channel: channel};
        new APIClient(API_URL + 'client/' + this.props.clientId + '/ignore-channel/').call('POST', body).then((data) => {
            if (data && data.status === 'OK') {
                this.fetchClientData();
            }
        });
    }

    handleUnignoreChannel(channel) {
        const body = {channel: channel};
        new APIClient(API_URL + 'client/' + this.props.clientId + '/unignore-channel/').call('POST', body).then((data) => {
            if (data && data.status === 'OK') {
                this.fetchClientData();
                this.handleConnectChannel(channel);
            }
        });
    }

    handleOpenAddBUModal() {
        if (this.addBUModal) {
            this.addBUModal.toggle();
        }
    }

    handleAfterSuccessfulBUSubmit(businessUnitId) {
        this.props.history.push(`/business-unit/${businessUnitId}/accounts?showAddAccountModal=true`);
    }

    render() {
        const isLoading = this.state.loadingClient && this.state.modules === null;
        const showHeader = this.props.showHeader !== false;
        const showTabs = this.props.showTabs !== false;
        const readOnly = this.props.readOnly === true;

        if (isLoading) {
            return (
                <section className="section-content">
                    {showHeader && <ClientHeader name={this.state.name}/>}
                    {showTabs && <ClientTabs clientId={this.props.clientId} activeTab="-first"/>}
                    <div className="section-body" style={{display: 'flex', justifyContent: 'center', padding: '3em 0'}}>
                        <Spinner color="positive"/>
                    </div>
                </section>
            );
        }

        const businessUnits = (this.state.businessUnits || []).map(bu => ({
            id: bu.id,
            name: bu.name,
        }));
        const showActivityLogPreview = !readOnly && this.hasActivityLogModule();
        const showReportsPreview = this.hasReportsModule();

        return (
            <section className="section-content">
                {showHeader && <ClientHeader name={this.state.name}/>}
                {showTabs && <ClientTabs clientId={this.props.clientId} activeTab="-first"/>}

                <div className="section-body">
                    <div className={`control-central-grid${showActivityLogPreview ? ' -with-activity-log' : ''}`}>
                        <div className="control-central-main-column">
                            <div className="control-central-lines-row">
                                <BUSummaryBox
                                    businessUnits={this.state.businessUnits}
                                    clientId={this.props.clientId}
                                    clientName={this.state.name}
                                    clientAdAccounts={this.state.clientAdAccounts}
                                    onAddBU={readOnly ? null : this.handleOpenAddBUModal}
                                    canAddBU={!readOnly}
                                    showAll={true}
                                    expandedByDefault={true}
                                    showAccountControls={true}
                                    onAccountsChanged={this.fetchClientData.bind(this)}
                                    onControlLineDeleted={this.fetchClientData.bind(this)}
                                />
                            </div>

                            <div className="control-central-overview-grid">
                                <div className="control-central-platforms-row">
                                    <PlatformsBox
                                        clientId={this.props.clientId}
                                        clientAdAccounts={this.state.clientAdAccounts}
                                        clientStores={this.state.clientStores}
                                        channels={this.state.channels}
                                        ignoredChannels={this.state.ignoredChannels}
                                        onConnectChannel={this.handleConnectChannel}
                                        onUnignoreChannel={this.handleUnignoreChannel}
                                        readOnly={readOnly}
                                    />
                                </div>

                                <div className="control-central-users-row">
                                    <ClientUsersPreviewBox clientId={this.props.clientId}/>
                                </div>

                                {showReportsPreview && (
                                    <div className="control-central-reports-row">
                                        <ReportsPreviewBox
                                            clientId={this.props.clientId}
                                            reports={this.state.reports}
                                            onDeleteReport={this.handleDeleteReport}
                                            onCancelReport={this.handleCancelReport}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>

                        {showActivityLogPreview && (
                            <div className="control-central-activity-log-column">
                                <ActivityLogPreviewBox
                                    clientId={this.props.clientId}
                                    entries={(this.state.activityLogEntries || []).slice(0, 10)}
                                    loading={this.state.loadingActivityLog}
                                    onAddNote={this.toggleCommentModal}
                                />
                            </div>
                        )}
                    </div>
                </div>

                {!readOnly && (
                    <ActivityLogCommentModal
                        isOpen={this.state.showCommentModal}
                        toggle={this.toggleCommentModal}
                        businessUnits={businessUnits}
                        onSubmit={this.handleCommentSubmit}
                        isSubmitting={this.state.isSubmittingComment}
                    />
                )}

                <AddBusinessUnitModal
                    ref={instance => { this.addBUModal = instance; }}
                    clientId={this.props.clientId}
                    clientName={this.state.name}
                    afterSuccessfulSubmit={this.handleAfterSuccessfulBUSubmit}
                    history={this.props.history}
                />

                <QuickConnectAccountModal
                    isOpen={this.state.showConnectModal}
                    toggle={this.toggleConnectModal}
                    channel={this.state.connectModalChannel}
                    clientId={this.props.clientId}
                    onSuccess={this.handleConnectSuccess}
                />

                <TemplatePickerModal
                    isOpen={this.state.showTemplateModal}
                    toggle={this.toggleTemplateModal}
                    clientId={this.props.clientId}
                    onGenerate={this.handleGenerateTemplate}
                    generating={this.state.generating}
                />
            </section>
        );
    }
}

export const ControlCentralContent = withTranslation()(ControlCentralContentClass);
